module.exports = __webpack_public_path__ + "img/homePageConfigure-active.98312ae0.svg";